import { Inject, Injectable } from '@angular/core';
import { Sgkz022aRequest, SGKZ022AService, ConstSystemCodeDto, ConstSystemCodeInfoMstDto, GeneralSystemConstInfoCacheDto } from 'sg-api';
import { catchError, map, timeout } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { ApiCommonService } from 'cbc-shared-lib';
import { FeaturesLibConfig } from '../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../config/features-lib-config.token';


/**
 * 引数で指摘したシステム定数コードに紐づく汎用システム定数情報マスタのデータを取得して返却する。
 * 
 * @export
 * @class GeneralSystemConstInfoMstService
 */
@Injectable({
  providedIn: 'root'
})
export class GeneralSystemConstInfoMstService {

  /**
   * コンストラクタ
   * @memberof GeneralSystemConstInfoMstService
   */
  constructor(private sGKZ022AService: SGKZ022AService, private apiCommonService: ApiCommonService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * 汎用システム定数情報マスタ取得
   * 
   * @param sysDefCodeList システム定数コードリスト
   * @returns 汎用システム定数情報マスタ（key:システム定数コード）
   * @memberof GeneralSystemConstInfoMstService
   */
  public getGeneralSystemConstInfoMst(sysDefCodeList: string[]): Observable<Map<string, Array<GeneralSystemConstInfoCacheDto>>> {

    let sysDefCodeDtoList = new Array<ConstSystemCodeDto>;
    for (let sysDefCode of sysDefCodeList) {
      let request: ConstSystemCodeDto = {
        sysDefCode: sysDefCode
      };

      sysDefCodeDtoList.push(request);
    }

    let request: Sgkz022aRequest = {
      sysDefCodeList: sysDefCodeDtoList
    }

    return this.sGKZ022AService.kz10RSGKZ022APost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);

            let result = new Map<string, Array<GeneralSystemConstInfoCacheDto>>();
            for (let key in response.body.generalSystemConstInfoMstTbl) {

              let cacheDtoList :Array<GeneralSystemConstInfoCacheDto> = [];
              cacheDtoList = response.body.generalSystemConstInfoMstTbl[key].map((mstDto) => ({
                codeSequenceNumber: mstDto.sysdefCodeSqcno,
                settingValueText: mstDto.sysdefSupvalText,
                contentText: mstDto.sysdefContText,
                commentInformationText: mstDto.comentInfoText,
              }));

              result.set(key, cacheDtoList);
            }

            return result;
          }),

        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'sys', 'SGKZ022A');
          return throwError(err.message);
        })
      );
  }
}
